import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronUp } from "@air/next-icons";
import { Badge } from "@air/primitive-badge";
import { useAirModal } from "@air/provider-modal";
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import { useFormikContext } from "formik";
import { CustomFieldFormAPIInformationCopyValue } from "~/components/CustomFields/CustomFieldModal/CustomFieldModalForm/CustomFieldModalFormAPIInformationCopyValue";
import { ChilipiperModal } from "~/components/Modals/ChilipiperModal";
import { useIsAdminEnterpriseMember } from "~/hooks/useAdminEnterpriseMember";
import { useCurrentWorkspacePermissionsContext } from "~/providers/CurrentWorkspacePermissionsProvider";
import { canManageSubscription } from "~/utils/permissions/workspacePermissions";
export const CustomFieldModalFormAPIInformation = ()=>{
    var _values_values;
    const { isAdminEnterpriseMember } = useIsAdminEnterpriseMember();
    const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
    const [showContactSalesModal] = useAirModal(ChilipiperModal);
    const { values } = useFormikContext();
    const canEditPlan = canManageSubscription(workspacePermissions);
    if (!values.id) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-6 flex flex-col gap-6 border-t border-t-grey-5 pt-6",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-12 font-semibold text-grey-11",
                        children: "Field ID"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-1",
                        children: isAdminEnterpriseMember ? /*#__PURE__*/ _jsx(CustomFieldFormAPIInformationCopyValue, {
                            id: values.id
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "text-12 text-grey-9",
                            children: [
                                "Upgrade to Enterprise to access API info.",
                                " ",
                                canEditPlan ? /*#__PURE__*/ _jsx("button", {
                                    className: "mr-1 inline text-grey-12 hover:underline",
                                    onClick: ()=>showContactSalesModal({
                                            uiLocation: "asset_modal_api_cta"
                                        }),
                                    type: "button",
                                    children: "Contact sales →"
                                }) : "Contact a workspace admin to upgrade."
                            ]
                        })
                    })
                ]
            }),
            isAdminEnterpriseMember && !!(values === null || values === void 0 ? void 0 : (_values_values = values.values) === null || _values_values === void 0 ? void 0 : _values_values.length) && /*#__PURE__*/ _jsxs(RadixCollapsible.Root, {
                className: "flex flex-col gap-2",
                defaultOpen: false,
                children: [
                    /*#__PURE__*/ _jsx(RadixCollapsible.Trigger, {
                        className: "group",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-1 text-12 font-semibold text-grey-11",
                            children: [
                                "Option IDs",
                                /*#__PURE__*/ _jsx(ChevronUp, {
                                    className: "size-4 group-radix-state-open:rotate-180"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(RadixCollapsible.Content, {
                        className: "flex flex-col gap-1",
                        children: values.values.map((value)=>{
                            var _value_color, _value_color1;
                            return /*#__PURE__*/ _jsx("div", {
                                className: "flex gap-1",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-2 text-12 text-grey-9",
                                    children: [
                                        /*#__PURE__*/ _jsx(Badge, {
                                            style: {
                                                backgroundColor: (_value_color = value.color) === null || _value_color === void 0 ? void 0 : _value_color.backgroundHex,
                                                color: (_value_color1 = value.color) === null || _value_color1 === void 0 ? void 0 : _value_color1.fontHex
                                            },
                                            children: value.value
                                        }),
                                        /*#__PURE__*/ _jsx(CustomFieldFormAPIInformationCopyValue, {
                                            id: value.id
                                        })
                                    ]
                                })
                            }, value.id);
                        })
                    })
                ]
            })
        ]
    });
};
